module.exports = __webpack_public_path__ + "img/DSC_0655.1a8873f8.png";